// Example locale file for English, give this to your locale team to translate

export default {
  // Set Filter
  selectAll: '(Alle auswählen)',
  selectAllSearchResults: '(Alle Suchergebnisse auswählen)',
  searchOoo: 'Suchen...',
  blanks: '(Leer)',
  noMatches: 'Keine Treffer',

  // Number Filter & Text Filter
  filterOoo: 'Filter...',
  equals: 'Gleich',
  notEqual: 'Ungleich',
  blank: 'Leer',
  notBlank: 'Nicht leer',
  empty: 'Einen auswählen',

  // Number Filter
  lessThan: 'Weniger als',
  greaterThan: 'Mehr als',
  lessThanOrEqual: 'Kleiner/Gleich',
  greaterThanOrEqual: 'Größer/Gleich',
  inRange: 'Im Bereich',
  inRangeStart: 'von',
  inRangeEnd: 'bis',

  // Text Filter
  contains: 'Enthält',
  notContains: 'Enthält nicht',
  startsWith: 'Beginnt mit',
  endsWith: 'Endet mit',

  // Date Filter
  dateFormatOoo: 'dd.mm.yyyy',

  // Filter Conditions
  andCondition: 'UND',
  orCondition: 'ODER',

  // Filter Buttons
  applyFilter: 'Anwenden',
  resetFilter: 'Reset',
  clearFilter: 'Entfernen',
  cancelFilter: 'Abbrechen',

  // Filter Titles
  textFilter: 'Text Filter',
  numberFilter: 'Nummern Filter',
  dateFilter: 'Datum Filter',
  setFilter: 'Mengen Filter',

  // Side Bar
  columns: 'Spalten',
  filters: 'Filter',

  // columns tool panel
  pivotMode: 'Pivot Modus',
  groups: 'Zeilen Gruppen',
  rowGroupColumnsEmptyMessage: 'Hierher ziehen, um Zeilen zu gruppieren',
  values: 'Werte',
  valueColumnsEmptyMessage: 'Hierher ziehen zum Aggregieren',
  pivots: 'Spalten Labels',
  pivotColumnsEmptyMessage: 'Hierher ziehen, um Spalten Labels zu setzen',

  // Header of the Default Group Column
  group: 'Gruppe',

  // Row Drag
  rowDragRows:'Reihen',

  // Other
  loadingOoo: 'Lade...',
  noRowsToShow: 'Keine Zeilen zum Anzeigen',
  enabled: 'aktiviert',

  // Menu
  pinColumn: 'Spalte anpinnen',
  pinLeft: 'Links anpinnen',
  pinRight: 'Rechts anpinnen',
  noPin: 'Nicht anpinnen',
  valueAggregation: 'Werteaggregation',
  autosizeThiscolumn: 'Spaltengröße automatisch auswählen',
  autosizeAllColumns: 'Alle Spaltengrößen automatisch auswählen',
  groupBy: 'Gruppieren nach',
  ungroupBy: 'Gruppierung aufheben',
  addToValues: '${variable} zu Werten hinzufügen',
  removeFromValues: '${variable} aus Werten entfernen',
  addToLabels: '${variable} zu Labels hinzufügen',
  removeFromLabels: '${variable} aus Labels entfernen',
  resetColumns: 'Spalten zurücksetzen',
  expandAll: 'Alle ausklappen',
  collapseAll: 'Alle schließen',
  copy: 'Kopieren',
  ctrlC: 'Ctrl+C',
  copyWithHeaders: 'Mit Überschriften kopieren',
  copyWithGroupHeaders: 'Mit Gruppenüberschriften kopieren',
  paste: 'Einfügen',
  ctrlV: 'Ctrl+V',
  export: 'Exportieren',
  csvExport: 'CSV Export',
  excelExport: 'Excel Export',

  // Enterprise Menu Aggregation and Status Bar
  sum: 'Summe',
  min: 'Min',
  max: 'Max',
  none: 'Keine',
  count: 'Anzahl',
  avg: 'Durchschnitt',
  filteredRows: 'Gefiltert',
  selectedRows: 'Ausgewählt',
  totalRows: 'Gesamt',
  totalAndFilteredRows: 'Zeilen',
  more: 'Mehr',
  to: 'bis',
  of: 'von',
  page: 'Seite',
  nextPage: 'Nächste Seite',
  lastPage: 'Letzte Seite',
  firstPage: 'Erste Seite',
  previousPage: 'Vorherige Seite',

  // Pivoting
  pivotColumnGroupTotals: 'Gesamt',

  // Enterprise Menu (Charts)
  pivotChartAndPivotMode: 'Pivot Diagramm & Pivot Modus',
  pivotChart: 'Pivot-Diagramm',
  chartRange: 'Diagramm-Bereich',

  columnChart: 'Spalte',
  groupedColumn: 'Gruppiert',
  stackedColumn: 'Gestapelt',
  normalizedColumn: '100% Gestapelt',

  barChart: 'Balkendiagramm',
  groupedBar: 'Gruppiert',
  stackedBar: 'Gestapelt',
  normalizedBar: '100% Gestapelt',

  pieChart: 'Tortendiagramm',
  pie: 'Torte',
  doughnut: 'Doughnutdiagramm',

  line: 'Line',

  xyChart: 'X Y (Scatter)',
  scatter: 'Scatter',
  bubble: 'Bubble',

  areaChart: 'Fläche',
  area: 'Fläche',
  stackedArea: 'Gestapelt',
  normalizedArea: '100% Gestapelt',

  histogramChart: 'Histogram',

  combinationChart: 'Kombination',
  columnLineCombo: 'Spalte und Linie',
  AreaColumnCombo: 'Fläche und Spalte',

  // Charts
  pivotChartTitle: 'Pivot-Diagramm',
  rangeChartTitle: 'Range-Diagramm',
  settings: 'Einstellungen',
  data: 'Daten',
  format: 'Format',
  categories: 'Kategorie',
  defaultCategory: '(Keine)',
  series: 'Serie',
  xyValues: 'X Y Werte',
  paired: 'Paarungs-Modus',
  axis: 'Achse',
  navigator: 'Navigator',
  color: 'Farbe',
  thickness: 'Dicke',
  xType: 'X Typ',
  automatic: 'Automatisch',
  category: 'Kategorie',
  number: 'Nummer',
  time: 'Zeit',
  autoRotate: 'Auto Rotation',
  xRotation: 'X Rotation',
  yRotation: 'Y Rotation',
  ticks: 'Unterteilung',
  width: 'Weite',
  height: 'Höhe',
  length: 'Länge',
  padding: 'Abstände',
  spacing: 'Abstand',
  chart: 'Diagram',
  title: 'Titel',
  titlePlaceholder: 'Diagramm Titel - Doppelklick zum Editieren',
  background: 'Hintergrund',
  font: 'Schriftart',
  top: 'Oben',
  right: 'Rechts',
  bottom: 'Unten',
  left: 'Links',
  labels: 'Labels',
  size: 'Größe',
  minSize: 'Minimalgröße',
  maxSize: 'Maximalgröße',
  legend: 'Legende',
  position: 'Position',
  markerSize: 'Marker Größe',
  markerStroke: 'Marker Strichgröße',
  markerPadding: 'Marker Abstände',
  itemSpacing: 'Elementgröße',
  itemPaddingX: 'Elementgröße X',
  itemPaddingY: 'Elementgröße Y',
  layoutHorizontalSpacing: 'Horizontale Abstände',
  layoutVerticalSpacing: 'Vertikale Abstände',
  strokeWidth: 'Strichbreite',
  offset: 'Offset',
  offsets: 'Offsets',
  tooltips: 'Tooltips',
  callout: 'Callout',
  markers: 'Marker',
  shadow: 'Schatten',
  blur: 'Blur',
  xOffset: 'X Offset',
  yOffset: 'Y Offset',
  lineWidth: 'Linienbreite',
  normal: 'Normal',
  bold: 'Bold',
  italic: 'Italic',
  boldItalic: 'Bold Italic',
  predefined: 'Predefined',
  fillOpacity: 'Fill Opacity',
  strokeOpacity: 'Line Opacity',
  histogramBinCount: 'Eimergröße',
  columnGroup: 'Zeile',
  barGroup: 'Balken',
  pieGroup: 'Torte',
  lineGroup: 'Linie',
  scatterGroup: 'X Y (Scatter)',
  areaGroup: 'Fläche',
  histogramGroup: 'Histogram',
  combinationGroup: 'Kombination',
  groupedColumnTooltip: 'Gruppiert',
  stackedColumnTooltip: 'Gestapelt',
  normalizedColumnTooltip: '100% Gestapelt',
  groupedBarTooltip: 'Gruppiert',
  stackedBarTooltip: 'Gestapelt',
  normalizedBarTooltip: '100% Gestapelt',
  pieTooltip: 'Torte',
  doughnutTooltip: 'Doughnut',
  lineTooltip: 'Linie',
  groupedAreaTooltip: 'Fläche',
  stackedAreaTooltip: 'Gestapelt',
  normalizedAreaTooltip: '100% Gestapelt',
  scatterTooltip: 'Scatter',
  bubbleTooltip: 'Bubble',
  histogramTooltip: 'Histogram',
  columnLineComboTooltip: 'Spalte & Linie',
  areaColumnComboTooltip: 'Fläche & Spalte',
  customComboTooltip: 'Benutzerdefinierte Kombination',
  noDataToChart: 'Keine Daten für ein Diagramm verfügbar',
  pivotChartRequiresPivotMode: 'Pivot Diagramm erfordert das Auswählen des Pivot Modus',
  chartSettingsToolbarTooltip: 'Menü',
  chartLinkToolbarTooltip: 'Im Grid verlinken',
  chartUnlinkToolbarTooltip: 'Verlinkung im Grid aufheben',
  chartDownloadToolbarTooltip: 'Diagramm downloaden',
  seriesChartType: 'Serien Diagramm Typ',
  seriesType: 'Serien Typ',
  secondaryAxis: 'Sekundäre Achse',

  // ARIA
  ariaChecked: 'ausgewählt',
  ariaColumn: 'Spalte',
  ariaColumnGroup: 'Spalten Gruppe',
  ariaColumnList: 'Spalten Listek',
  ariaColumnSelectAll: 'Auswahl Alle Spalten umschalten',
  ariaDateFilterInput: 'Datumsfilter anwenden',
  ariaDefaultListName: 'Liste',
  ariaFilterColumnsInput: 'Spalteneingabe filtern',
  ariaFilterFromValue: 'Wert filtern',
  ariaFilterInput: 'Eingabe filtern',
  ariaFilterList: 'Filter Liste',
  ariaFilterToValue: 'Zum Wert filtern',
  ariaFilterValue: 'Wert filtern',
  ariaFilteringOperator: 'Filter Operator',
  ariaHidden: 'versteckt',
  ariaIndeterminate:'unentschieden',
  ariaInputEditor: 'Eingabe Editor',
  ariaMenuColumn: 'STRG ENTER, um Spalten Menü anzuzeigen',
  ariaRowDeselect: 'LEERZEICHEN, um Reihenauswahl aufzuheben',
  ariaRowSelectAll: 'LEERZEICHEN, um Reihenauswahl aufzuheben',
  ariaRowToggleSelection: 'LEERZEICHEN, um Reihenauswahl umzukehren',
  ariaRowSelect: 'LEERZEICHEN, um Reihe auszuwählen',
  ariaSearch: 'Suchen',
  ariaSortableColumn: 'ENTER, um zu sortieren',
  ariaToggleVisibility: 'LEERZEICHEN, um Sichtbarkeit umzukehren',
  ariaUnchecked: 'unausgewählt',
  ariaVisible: 'sichtbar',
  ariaSearchFilterValues: 'Filterwerte suchen',

  // ARIA Labels for Drop Zones

  ariaRowGroupDropZonePanelLabel: 'Zeilengruppen',
  ariaValuesDropZonePanelLabel: 'Werte',
  ariaPivotDropZonePanelLabel: 'Spalten Labels',
  ariaDropZoneColumnComponentDescription: 'ENTFERNEN drücken, um zu löschen',
  ariaDropZoneColumnValueItemDescription: 'ENTER drücken, um Aggregation auszuwählen',

  // ARIA Labels for Dialogs
  ariaLabelColumnMenu: 'Spaltenmenü',
  ariaLabelCellEditor: 'Zellen-Editor',
  ariaLabelDialog: 'Dialog',
  ariaLabelSelectField: 'Feld auswählen',
  ariaLabelTooltip: 'Tooltip',
  ariaLabelContextMenu: 'Kontextmenü',
  ariaLabelSubMenu: 'Untermenü',
  ariaLabelAggregationFunction: 'Aggregations Funktion',

  // Number Format (Status Bar, Pagination Panel)
  thousandSeparator: '.',
  decimalSeparator: ','

}